import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

interface IAgreementNumberCell {
  agreementNumberList: string[];
}

export function AgreementNumberCell<T extends IAgreementNumberCell>({ row }: Readonly<ITableRenderCell<T>>) {
  return <div>{row.agreementNumberList.join(', ')}</div>;
}
